module.exports = __webpack_public_path__ + "static/media/flagpole_data.ce27e22c.svg";